import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { productsData } from '../../mocks/products';

// Product-specific gallery images
const productGalleries: Record<string, string[]> = {
  'nova-5500': [
    'https://static.wixstatic.com/media/b85534_275c49b8698d44d2918543cdf35026c2~mv2.jpg/v1/fill/w_513,h_297,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_275c49b8698d44d2918543cdf35026c2~mv2.jpg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/708cb0f4f1413108110f0f3a5626ab56.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/ae50e4801745de0b0501270a1235dca1.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/95d1756f27fd138e664f7b1c23f84fbf.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/e9b90fedc51c16e70004c0cbb08059f9.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/951dcd545ab5d8509ac0b6219c63bfa8.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/0876d46005846cf4f5755fe8e6793d74.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/3ce8ba1b8c74fde50862a649969d5bfa.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/5e304628ff64e20ea1f4da6eaee9e240.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/d35a72d69f5f8c053647402b52a6fe7f.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/2d73349f6184f41454750046aefb19da.jpeg'
  ],
  'nr-led-mask': [
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/4d6d921269ebae6a67a49c42b8fc5a49.png',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/3204bd65a173b0b347eb38a60468619b.png',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/8269e7b315a1ba7c05d450585df3e22d.png'
  ],
  'nr-300a': [
    'https://i.ibb.co/FqXGJVc3/300-07.png',
    'https://i.ibb.co/S257ZM1/300-06.png',
    'https://i.ibb.co/B2sWjxwt/300-05.png',
    'https://i.ibb.co/GfMZPXpW/300-04.png',
    'https://i.ibb.co/GQmQTN2g/300-03.png',
    'https://i.ibb.co/fYxW4Nsc/300-02.png',
    'https://i.ibb.co/NdcF38SD/300-01.png'
  ],
  'nr-400a': [
    'https://i.ibb.co/nMx53V90/400-09.png',
    'https://i.ibb.co/HDKbyQdS/400-08.png',
    'https://i.ibb.co/qYGLMzNy/400-07.png',
    'https://i.ibb.co/Jwch3gTg/400-06.png',
    'https://i.ibb.co/N6tdQGsr/400-05.png',
    'https://i.ibb.co/9mTxvRds/400-04.png',
    'https://i.ibb.co/BV9MXkr3/400-03.png',
    'https://i.ibb.co/BVN75srC/400-02.png',
    'https://i.ibb.co/rDRyF41/400-01.png'
  ],
  'nr-600a': [
    'https://i.ibb.co/8gmjQsHR/600-01.png',
    'https://i.ibb.co/GQVFBgVK/600-02.png',
    'https://i.ibb.co/XkdzHV9C/600-03.png',
    'https://i.ibb.co/SXQQZgF9/600-04.png',
    'https://i.ibb.co/kVMTthcx/600-05.png'
  ],
  'nr-1000a': [
    'https://i.ibb.co/LDRSGq6L/1000-08.png',
    'https://i.ibb.co/TDdStzKh/1000-07.png',
    'https://i.ibb.co/qM8rcVJp/1000-06.png',
    'https://i.ibb.co/yF171yCK/1000-05.png',
    'https://i.ibb.co/5W0T89xn/1000-04.png',
    'https://i.ibb.co/7NyM8ryW/1000-03.png',
    'https://i.ibb.co/KzB51nP3/1000-02.png',
    'https://i.ibb.co/C5vnXnfn/1000-01.png'
  ],
  'nr-1500a': [
    'https://i.ibb.co/XxCMHhhH/1500-01.png',
    'https://i.ibb.co/gM5C0GbZ/1500-02.png',
    'https://i.ibb.co/5WvQFQLx/1500-03.png',
    'https://i.ibb.co/3wc3q2H/1500-04.png',
    'https://i.ibb.co/4R8RWd4X/1500-05.png'
  ],
  'nr-3000a': [
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/e162869f799f783b7c68efd483da7fab.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/2c5410629ae6b3c0bf769cba1a463445.jpeg'
  ],
  'nr-6000a': [
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/c1547c2241ced149d5b4b5a410b1fb88.webp',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/a9a246d613864f83171bcb24c1956a37.webp'
  ],
  'nova-r1160': [
    'https://static.wixstatic.com/media/b85534_776251e09e7f4ce5a93b76670fafb03b~mv2.jpg/v1/fill/w_510,h_286,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_776251e09e7f4ce5a93b76670fafb03b~mv2.jpg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/9e033317cf5a0dea892bd5167a955889.webp',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/59df87cc137c316d25cb4056f1b0d0cb.webp',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/ce3a35e1f5a9c160cd2b39d68117f5a8.webp',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/3b905a6f3424c20208402f9be18e2963.webp'
  ],
  'nova-r5200': [
    'https://static.wixstatic.com/media/b85534_dee6ff3a014b4cec8f807f79cc46643d~mv2.jpg/v1/fill/w_512,h_294,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_dee6ff3a014b4cec8f807f79cc46643d~mv2.jpg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/71b3ae7bc874fe65b88c52775e3adde1.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/188700e0c391d8504eb045076d0a2d2e.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/3f681c9838055676eaacd2ab1c7024c8.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/e52e1d6006e4e2ccfab97db43c6f2777.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/5c230231909e8c8d837f78e61f354279.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/f2a7f3852f4abc11281c7e58b6266ee6.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/a3956634fde2dda25fb8269346523566.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/8eea45e68251115df74eb07ef5b4453a.jpeg',
    'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/a456094055ad61adc91bbba9734a40bf.jpeg'
  ]
};

const ProductDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const product = productsData.find(p => p.id === slug);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  if (!product) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <main className="pt-32">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center py-20">
              <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-product-hunt-line text-gray-400 text-3xl"></i>
              </div>
              <h1 className="font-serif text-4xl font-light text-gray-900 mb-4">
                Product Not Found
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                The product you're looking for doesn't exist or may have been moved.
              </p>
              <Link 
                to="/products" 
                className="inline-block bg-teal-600 text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                View All Products
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // Get gallery images for this product, or use single product image
  const galleryImages = productGalleries[product.id] || [product.image];
  const currentImage = galleryImages[selectedImageIndex];

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-32">
        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-8">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-teal-600 cursor-pointer">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/products" className="hover:text-teal-600 cursor-pointer">Products</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">{product.name}</span>
          </div>
        </div>

        {/* Product Detail */}
        <section className="pb-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Image Gallery */}
              <div>
                {/* Main Image */}
                <div className="relative aspect-square rounded-lg overflow-hidden bg-gray-100 mb-4">
                  <img 
                    src={currentImage}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                  {product.badge && (
                    <div className="absolute top-6 right-6 bg-gray-900 text-white px-4 py-2 text-sm font-medium rounded-full">
                      {product.badge}
                    </div>
                  )}
                </div>
                
                {/* Thumbnails - only show if multiple images */}
                {galleryImages.length > 1 && (
                  <div className="flex gap-3">
                    {galleryImages.map((img, index) => (
                      <button
                        key={index}
                        onClick={() => setSelectedImageIndex(index)}
                        className={`w-20 h-20 rounded-md overflow-hidden border-2 transition-all cursor-pointer ${
                          selectedImageIndex === index 
                            ? 'border-teal-600 ring-2 ring-teal-200' 
                            : 'border-gray-200 hover:border-teal-400'
                        }`}
                      >
                        <img 
                          src={img}
                          alt={`${product.name} view ${index + 1}`}
                          className="w-full h-full object-cover"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Details */}
              <div>
                <div className="text-sm font-medium text-teal-600 mb-3">
                  {product.category}
                </div>
                <h1 className="font-serif text-4xl md:text-5xl font-light text-gray-900 mb-6">
                  {product.name}
                </h1>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  {product.description}
                </p>

                <div className="bg-teal-50 border border-teal-200 rounded-lg p-6 mb-8">
                  <div className="text-2xl font-medium text-teal-600 mb-2">
                    Request a Quote
                  </div>
                  <p className="text-sm text-gray-700 mb-4">
                    Contact us for pricing and availability
                  </p>
                  <Link 
                    to="/contact"
                    className="inline-block bg-teal-600 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Get a Quote
                  </Link>
                </div>

                {/* Features */}
                <div className="mb-8">
                  <h2 className="font-serif text-2xl font-medium text-gray-900 mb-4">
                    Key Features
                  </h2>
                  <ul className="space-y-3">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Specifications */}
            <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-6">
                  Technical Specifications
                </h2>
                <div className="bg-gray-50 rounded-lg p-6">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-3 font-medium text-gray-900">Specification</th>
                          <th className="text-right py-3 font-medium text-gray-900">Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(product.specifications).map(([key, value]) => (
                          <tr key={key} className="border-b border-gray-200">
                            <td className="py-3 text-gray-900">{key}</td>
                            <td className="py-3 text-gray-700 text-right">{value}</td>
                          </tr>
                        ))}
                        
                        {/* Additional Panel-specific specifications */}
                        {product.id === 'nr-1000a' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Nominal Power</td>
                              <td className="py-3 text-gray-700 text-right">1000W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">LED Count</td>
                              <td className="py-3 text-gray-700 text-right">200 LEDs</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Wavelengths</td>
                              <td className="py-3 text-gray-700 text-right">630nm / 660nm / 810nm / 850nm</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Beam Angle</td>
                              <td className="py-3 text-gray-700 text-right">60°</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Irradiance at 3 inches</td>
                              <td className="py-3 text-gray-700 text-right">129 mW/cm²</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Irradiance at 6 inches</td>
                              <td className="py-3 text-gray-700 text-right">95 mW/cm²</td>
                            </tr>
                          </>
                        )}
                        
                        {product.id === 'nr-1500a' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Nominal Power</td>
                              <td className="py-3 text-gray-700 text-right">1500W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">LED Count</td>
                              <td className="py-3 text-gray-700 text-right">300 LEDs</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Wavelengths</td>
                              <td className="py-3 text-gray-700 text-right">630nm / 660nm / 810nm / 850nm</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Beam Angle</td>
                              <td className="py-3 text-gray-700 text-right">60°</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Irradiance at 3 inches</td>
                              <td className="py-3 text-gray-700 text-right">133 mW/cm²</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Irradiance at 6 inches</td>
                              <td className="py-3 text-gray-700 text-right">114 mW/cm²</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Treatment Area Coverage</td>
                              <td className="py-3 text-gray-700 text-right">24" × 14" (optimal distance)</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Power Consumption</td>
                              <td className="py-3 text-gray-700 text-right">150W actual draw</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Operating Temperature</td>
                              <td className="py-3 text-gray-700 text-right">32°F to 104°F (0°C to 40°C)</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Cooling</td>
                              <td className="py-3 text-gray-700 text-right">Passive heat dissipation</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Mounting Options</td>
                              <td className="py-3 text-gray-700 text-right">Wall mount, door mount, tabletop</td>
                            </tr>
                          </>
                        )}
                        
                        {product.id === 'nr-3000a' && product.specifications['Power Output'] && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Nominal Power</td>
                              <td className="py-3 text-gray-700 text-right">3000W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Beam Angle</td>
                              <td className="py-3 text-gray-700 text-right">60°</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Pulse Function</td>
                              <td className="py-3 text-gray-700 text-right">0–9999 Hz</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Timer</td>
                              <td className="py-3 text-gray-700 text-right">5–60 minutes</td>
                            </tr>
                          </>
                        )}
                        
                        {product.id === 'nr-6000a' && product.specifications['Power Output'] && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Nominal Power</td>
                              <td className="py-3 text-gray-700 text-right">6000W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Timer</td>
                              <td className="py-3 text-gray-700 text-right">5–60 minutes</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Pulse Function</td>
                              <td className="py-3 text-gray-700 text-right">0–9999 Hz</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">LED Lifespan</td>
                              <td className="py-3 text-gray-700 text-right">50,000 hours</td>
                            </tr>
                          </>
                        )}
                        
                        {/* Nova-5500 specifications */}
                        {product.id === 'nova-5500' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Nominal System Power</td>
                              <td className="py-3 text-gray-700 text-right">6000W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Maximum Irradiance</td>
                              <td className="py-3 text-gray-700 text-right">Up to 129 mW/cm²</td>
                            </tr>
                          </>
                        )}
                        
                        {/* Nova-R5200 specifications */}
                        {product.id === 'nova-r5200' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Nominal System Power</td>
                              <td className="py-3 text-gray-700 text-right">4000W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Maximum Irradiance</td>
                              <td className="py-3 text-gray-700 text-right">Up to 129 mW/cm²</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Electrical Requirements</td>
                              <td className="py-3 text-gray-700 text-right">100–240V / 50–60Hz</td>
                            </tr>
                          </>
                        )}
                        
                        {/* NR LED Facial Mask specifications */}
                        {product.id === 'nr-led-mask' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Wavelength Modes</td>
                              <td className="py-3 text-gray-700 text-right">630nm (Red) / 460nm (Blue) / 605nm (Yellow) / 850nm (NIR)</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Lamp Beads</td>
                              <td className="py-3 text-gray-700 text-right">72</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Beam Count</td>
                              <td className="py-3 text-gray-700 text-right">288</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Energy Density</td>
                              <td className="py-3 text-gray-700 text-right">46 mW/cm²</td>
                            </tr>
                          </>
                        )}
                        
                        {/* HG07 Mat specifications */}
                        {product.id === 'nr-hg07' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">LED Count</td>
                              <td className="py-3 text-gray-700 text-right">1260</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Wavelengths</td>
                              <td className="py-3 text-gray-700 text-right">660nm / 850nm</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Max Power</td>
                              <td className="py-3 text-gray-700 text-right">90W</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Irradiance</td>
                              <td className="py-3 text-gray-700 text-right">124 mW</td>
                            </tr>
                          </>
                        )}
                        
                        {/* HG08 Mat specifications */}
                        {product.id === 'nr-hg08' && (
                          <>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">LED Count</td>
                              <td className="py-3 text-gray-700 text-right">2520</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Wavelengths</td>
                              <td className="py-3 text-gray-700 text-right">660nm / 850nm</td>
                            </tr>
                            <tr className="border-b border-gray-200">
                              <td className="py-3 text-gray-900">Max Power</td>
                              <td className="py-3 text-gray-700 text-right">250W</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                
                {/* Panel-specific footnote */}
                {(product.category === 'Panels' || product.category === 'Panels with Stand') && (
                  <p className="text-xs text-gray-500 mt-3 italic">
                    Irradiance values vary based on distance, configuration, and measurement conditions.
                  </p>
                )}
                
                {/* Bed-specific footnote */}
                {product.category === 'Therapy Beds' && (
                  <p className="text-xs text-gray-500 mt-3 italic">
                    Performance values vary by mode, distance, configuration, and measurement conditions.
                  </p>
                )}
                
                {/* Facial Mask and Mat footnote */}
                {(product.id === 'nr-led-mask' || product.id === 'nr-hg07' || product.id === 'nr-hg08') && (
                  <p className="text-xs text-gray-500 mt-3 italic">
                    Performance values vary by mode, distance, configuration, and measurement conditions.
                  </p>
                )}
              </div>

              {/* Applications */}
              <div>
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-6">
                  Applications
                </h2>
                <ul className="space-y-3">
                  {product.applications.map((application, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-star-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{application}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Treatment Protocols & Usage Guidelines */}
            {product.id === 'nr-1500a' && (
              <div className="mt-16">
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-8">
                  Treatment Protocols & Usage Guidelines
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-xl font-medium text-gray-900 mb-4">
                      Recommended Treatment Distances
                    </h3>
                    <div className="space-y-3">
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-700">3-6 inches</span>
                        <span className="text-sm text-teal-600 font-medium">Intensive targeted therapy</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-700">6-12 inches</span>
                        <span className="text-sm text-teal-600 font-medium">General wellness sessions</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-700">12-24 inches</span>
                        <span className="text-sm text-teal-600 font-medium">Broader area coverage</span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span className="text-gray-700">24+ inches</span>
                        <span className="text-sm text-teal-600 font-medium">Ambient whole-body exposure</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-xl font-medium text-gray-900 mb-4">
                      Session Duration Guidelines
                    </h3>
                    <div className="space-y-3">
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-700">5-10 minutes</span>
                        <span className="text-sm text-teal-600 font-medium">New users / Sensitive areas</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-700">10-15 minutes</span>
                        <span className="text-sm text-teal-600 font-medium">Standard sessions</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-700">15-20 minutes</span>
                        <span className="text-sm text-teal-600 font-medium">Experienced users</span>
                      </div>
                      <div className="flex justify-between items-center py-2">
                        <span className="text-gray-700">20+ minutes</span>
                        <span className="text-sm text-teal-600 font-medium">Professional protocols only</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
                  <h3 className="text-lg font-medium text-blue-900 mb-3">
                    Professional Usage Notes
                  </h3>
                  <ul className="space-y-2 text-blue-800 text-sm">
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                      <span>Begin with shorter sessions (5-10 minutes) and gradually increase duration based on individual response</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                      <span>Daily use is common, though some protocols recommend 3-5 sessions per week</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                      <span>Consistency typically more important than intensity for wellness applications</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-information-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                      <span>Sessions may be incorporated before or after physical therapy, training, or wellness activities</span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {/* Safety & Contraindications */}
            {product.id === 'nr-1500a' && (
              <div className="mt-16">
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-8">
                  Safety Information & Contraindications
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <h3 className="text-xl font-medium text-red-900 mb-4 flex items-center gap-2">
                      <i className="ri-alert-line text-red-600"></i>
                      Important Safety Guidelines
                    </h3>
                    <ul className="space-y-3 text-red-800 text-sm">
                      <li className="flex items-start gap-2">
                        <i className="ri-eye-line text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Eye Protection Required:</strong> Never look directly into LEDs. Use provided eye protection or keep eyes closed during treatment</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-temp-hot-line text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Heat Sensitivity:</strong> Discontinue if excessive warmth or discomfort occurs. Allow cooling between sessions if needed</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-medicine-bottle-line text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Photosensitive Medications:</strong> Consult healthcare provider if taking light-sensitive medications</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-user-forbid-line text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Pregnancy:</strong> Avoid use during pregnancy without healthcare provider approval</span>
                      </li>
                    </ul>
                  </div>
                  
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                    <h3 className="text-xl font-medium text-yellow-900 mb-4 flex items-center gap-2">
                      <i className="ri-error-warning-line text-yellow-600"></i>
                      Contraindications
                    </h3>
                    <ul className="space-y-3 text-yellow-800 text-sm">
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-yellow-600 flex-shrink-0 mt-0.5"></i>
                        <span>Active cancer treatment area (without oncologist approval)</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-yellow-600 flex-shrink-0 mt-0.5"></i>
                        <span>Open wounds or active infections</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-yellow-600 flex-shrink-0 mt-0.5"></i>
                        <span>Severe photosensitivity disorders</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-yellow-600 flex-shrink-0 mt-0.5"></i>
                        <span>Recent steroid injections in treatment area</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-circle-line text-yellow-600 flex-shrink-0 mt-0.5"></i>
                        <span>Thyroid conditions (neck/throat treatment)</span>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="mt-6 bg-gray-100 border border-gray-300 rounded-lg p-6">
                  <p className="text-sm text-gray-700 italic">
                    <strong>Disclaimer:</strong> This device is not intended to diagnose, treat, cure, or prevent any disease. Information provided is for educational purposes only and does not constitute medical advice. Consult with a healthcare professional before beginning any therapy regimen, especially if you have existing health conditions or are taking medications.
                  </p>
                </div>
              </div>
            )}

            {/* Facility Planning & Integration */}
            {product.id === 'nr-1500a' && (
              <div className="mt-16">
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-8">
                  Facility Planning & Integration
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-ruler-2-line text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-3">
                      Space Requirements
                    </h3>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• Minimum 6' × 8' treatment area</li>
                      <li>• Wall mounting or mobile stand options</li>
                      <li>• Standard 110V outlet required</li>
                      <li>• Adequate ventilation recommended</li>
                      <li>• Privacy considerations for patient comfort</li>
                    </ul>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-user-settings-line text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-3">
                      Staff Training
                    </h3>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• Basic device operation (30 minutes)</li>
                      <li>• Safety protocols and eye protection</li>
                      <li>• Treatment positioning guidelines</li>
                      <li>• Patient screening procedures</li>
                      <li>• Documentation and record keeping</li>
                    </ul>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                      <i className="ri-calendar-schedule-line text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-3">
                      Workflow Integration
                    </h3>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li>• Pre-therapy warm-up sessions</li>
                      <li>• Post-exercise recovery protocols</li>
                      <li>• Between-treatment wellness sessions</li>
                      <li>• Standalone wellness appointments</li>
                      <li>• Home program education</li>
                    </ul>
                  </div>
                </div>
                
                <div className="mt-8 bg-teal-50 border border-teal-200 rounded-lg p-6">
                  <h3 className="text-lg font-medium text-teal-900 mb-3">
                    Implementation Timeline
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="text-center">
                      <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-2 text-sm font-bold">1</div>
                      <div className="text-sm font-medium text-teal-900">Week 1</div>
                      <div className="text-xs text-teal-700">Installation & Setup</div>
                    </div>
                    <div className="text-center">
                      <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-2 text-sm font-bold">2</div>
                      <div className="text-sm font-medium text-teal-900">Week 2</div>
                      <div className="text-xs text-teal-700">Staff Training</div>
                    </div>
                    <div className="text-center">
                      <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-2 text-sm font-bold">3</div>
                      <div className="text-sm font-medium text-teal-900">Week 3</div>
                      <div className="text-xs text-teal-700">Pilot Program</div>
                    </div>
                    <div className="text-center">
                      <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-2 text-sm font-bold">4</div>
                      <div className="text-sm font-medium text-teal-900">Week 4+</div>
                      <div className="text-xs text-teal-700">Full Integration</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Scientific Background */}
            {product.id === 'nr-1500a' && (
              <div className="mt-16">
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-8">
                  Scientific Background & Research
                </h2>
                <div className="bg-gray-50 rounded-lg p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                      <h3 className="text-xl font-medium text-gray-900 mb-4">
                        Photobiomodulation Mechanisms
                      </h3>
                      <div className="space-y-4 text-gray-700">
                        <div>
                          <h4 className="font-medium text-gray-900 mb-2">Cellular ATP Production</h4>
                          <p className="text-sm">Red and near-infrared light interacts with cytochrome c oxidase in mitochondria, potentially enhancing ATP synthesis and cellular energy production.</p>
                        </div>
                        <div>
                          <h4 className="font-medium text-gray-900 mb-2">Nitric Oxide Modulation</h4>
                          <p className="text-sm">Light therapy may influence nitric oxide release, affecting vascular function and cellular signaling pathways.</p>
                        </div>
                        <div>
                          <h4 className="font-medium text-gray-900 mb-2">Inflammatory Response</h4>
                          <p className="text-sm">Research suggests potential modulation of inflammatory markers and oxidative stress through light-tissue interactions.</p>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-xl font-medium text-gray-900 mb-4">
                        Wavelength Specifications
                      </h3>
                      <div className="space-y-4">
                        <div className="border border-gray-200 rounded-lg p-4">
                          <h4 className="font-medium text-red-600 mb-2">660nm Red Light</h4>
                          <ul className="text-sm text-gray-700 space-y-1">
                            <li>• Penetration depth: 1-2 cm</li>
                            <li>• Primary targets: Surface tissues, skin</li>
                            <li>• Research focus: Wound healing, skin health</li>
                          </ul>
                        </div>
                        <div className="border border-gray-200 rounded-lg p-4">
                          <h4 className="font-medium text-red-800 mb-2">850nm Near-Infrared</h4>
                          <ul className="text-sm text-gray-700 space-y-1">
                            <li>• Penetration depth: 3-5 cm</li>
                            <li>• Primary targets: Deeper tissues, muscle</li>
                            <li>• Research focus: Muscle recovery, joint health</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mt-8 pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-600 italic">
                      <strong>Research Note:</strong> While photobiomodulation research continues to expand, individual results may vary. This information is provided for educational purposes and should not be considered medical advice. Consult healthcare professionals for specific clinical applications.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Maintenance & Care */}
            {product.id === 'nr-1500a' && (
              <div className="mt-16">
                <h2 className="font-serif text-3xl font-medium text-gray-900 mb-8">
                  Maintenance & Care Instructions
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-tools-line text-teal-600"></i>
                      Routine Maintenance
                    </h3>
                    <div className="space-y-4">
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Daily</h4>
                        <ul className="text-sm text-gray-700 space-y-1">
                          <li>• Wipe LED surface with soft, dry microfiber cloth</li>
                          <li>• Check power connections</li>
                          <li>• Verify timer and control functions</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Weekly</h4>
                        <ul className="text-sm text-gray-700 space-y-1">
                          <li>• Clean exterior housing with mild soap solution</li>
                          <li>• Inspect mounting hardware (if wall-mounted)</li>
                          <li>• Test all control settings</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Monthly</h4>
                        <ul className="text-sm text-gray-700 space-y-1">
                          <li>• Inspect power cord for damage</li>
                          <li>• Check LED array for any non-functioning units</li>
                          <li>• Verify mounting security</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-alert-line text-orange-600"></i>
                      Troubleshooting Guide
                    </h3>
                    <div className="space-y-4">
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Device Won't Turn On</h4>
                        <ul className="text-sm text-gray-700 space-y-1">
                          <li>• Check power cord connection</li>
                          <li>• Verify outlet functionality</li>
                          <li>• Inspect control switch</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Reduced Light Output</h4>
                        <ul className="text-sm text-gray-700 space-y-1">
                          <li>• Clean LED surface thoroughly</li>
                          <li>• Check for loose connections</li>
                          <li>• Contact support if issue persists</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-900 mb-2">Timer Malfunction</h4>
                        <ul className="text-sm text-gray-700 space-y-1">
                          <li>• Reset device (power cycle)</li>
                          <li>• Check control settings</li>
                          <li>• Review user manual</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-6">
                  <h3 className="text-lg font-medium text-blue-900 mb-3">
                    Professional Service & Support
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="text-center">
                      <i className="ri-phone-line text-blue-600 text-2xl mb-2"></i>
                      <div className="font-medium text-blue-900">Technical Support</div>
                      <div className="text-sm text-blue-700">Available during business hours</div>
                    </div>
                    <div className="text-center">
                      <i className="ri-video-line text-blue-600 text-2xl mb-2"></i>
                      <div className="font-medium text-blue-900">Virtual Assistance</div>
                      <div className="text-sm text-blue-700">Remote troubleshooting available</div>
                    </div>
                    <div className="text-center">
                      <i className="ri-service-line text-blue-600 text-2xl mb-2"></i>
                      <div className="font-medium text-blue-900">On-Site Service</div>
                      <div className="text-sm text-blue-700">Available for qualified issues</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Typical Session & Facility Integration */}
            <div className="mt-16">
              <h2 className="font-serif text-3xl font-medium text-gray-900 mb-6">
                Typical Session & Facility Integration
              </h2>
              <div className="bg-gray-50 rounded-lg p-8">
                <p className="text-gray-700 leading-relaxed">
                  Typical sessions are commonly 10–20 minutes depending on protocol and treatment area. Facilities often integrate sessions before or after training/therapy visits, or between visits as part of a recovery workflow. Protocols vary by facility and client goals.
                </p>
              </div>
            </div>

            {/* Documentation */}
            <div className="mt-16">
              <h2 className="font-serif text-3xl font-medium text-gray-900 mb-6">
                Documentation
              </h2>
              <div className="bg-white border border-gray-200 rounded-lg p-8">
                <p className="text-gray-700 leading-relaxed mb-6">
                  Technical specification sheets, performance testing summaries, and compliance documentation are available upon request for credentialing, procurement, and facility review. Documentation varies by model and configuration.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link 
                    to="/contact"
                    className="inline-block bg-teal-600 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap text-center"
                  >
                    Request Technical Spec Sheet
                  </Link>
                  <Link 
                    to="/contact"
                    className="inline-block bg-gray-900 text-white px-6 py-3 rounded-md text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap text-center"
                  >
                    Request a Quote
                  </Link>
                  <Link 
                    to="/contact"
                    className="inline-block text-teal-600 hover:text-teal-700 px-6 py-3 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap border border-teal-600 hover:border-teal-700 rounded-md"
                  >
                    Request Compliance Packet
                  </Link>
                </div>
              </div>
            </div>

            {/* Clinical Information */}
            <div className="mt-16 bg-gray-50 rounded-lg p-8">
              <h2 className="font-serif text-3xl font-medium text-gray-900 mb-6">
                Clinical Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-medium text-gray-900 mb-3">
                    Photobiomodulation Technology
                  </h3>
                  <p className="text-gray-700 mb-4">
                    Designed for adjunct use in professional environments. This system delivers specific wavelengths commonly studied in photobiomodulation research, including red (630-660nm) and near-infrared (810-850nm) light.
                  </p>
                  <p className="text-gray-700">
                    May support cellular processes through mitochondrial interaction and ATP synthesis pathways. Educational information only - not medical advice.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-900 mb-3">
                    Professional Use Guidelines
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 text-lg flex-shrink-0 mt-0.5"></i>
                      <span>Adjunct to standard care protocols</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 text-lg flex-shrink-0 mt-0.5"></i>
                      <span>Non-invasive application method</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 text-lg flex-shrink-0 mt-0.5"></i>
                      <span>Eye protection protocols required</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 text-lg flex-shrink-0 mt-0.5"></i>
                      <span>Staff training and screening considerations</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Implementation Support */}
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-text-line text-teal-600 text-xl"></i>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Documentation Ready
                </h3>
                <p className="text-gray-600 text-sm">
                  Compliance packets, technical specs, and procurement documentation available upon request.
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-teal-600 text-xl"></i>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  U.S. Support
                </h3>
                <p className="text-gray-600 text-sm">
                  Dedicated support team in U.S. time zones for installation, training, and ongoing service needs.
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-6 text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-settings-3-line text-teal-600 text-xl"></i>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Integration Support
                </h3>
                <p className="text-gray-600 text-sm">
                  Workflow integration guidance and operational best practices for clinical environments.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-16 bg-gray-900 rounded-lg p-12 text-center text-white">
              <h2 className="font-serif text-3xl md:text-4xl font-light mb-4">
                Ready to Get Started?
              </h2>
              <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
                Request a quote for detailed specifications, compliance documentation, and personalized recommendations for your facility.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link 
                  to="/contact"
                  className="inline-block bg-teal-500 text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Request a Quote
                </Link>
                <Link 
                  to="/compliance"
                  className="inline-block border border-gray-400 text-gray-300 hover:text-white hover:border-gray-300 px-8 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  Request Compliance Packet
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ProductDetail;
